import seo from '@/core/data/landingSeo.json'

const L = seo.locales.en

export default {
  landing: {
    title: L.title,
  },
  home: {
    title: L.title,
  },
  upload: {
    title: "Image Upload",
  },
  login: {
    title: "Login",
  },
  result: {
    title: "Image Analysis",
  },
  confirm: {
    title: "Email Confirmed",
  },
  terms: {
    title: "Terms of Service",
  },
  privacy: {
    title: "Privacy Policy",
  },
  blog: {
    title: "Photo Editing Guides & Concepts | PhotoScope Blog",
    subtitle:
      "Learn photo editing with reference photos. Explore practical guides on tone, color, and style gaps to help beginners edit with intention.",
  },
  history: {
    title: "History",
  },
  about: {
    title: "About Us - PhotoScope",
  },
  payment: {
    success: "Payment Successful",
    cancel: "Payment Cancelled",
  },
  dashboard: {
    title: "Dashboard",
  },
  tools: {
    title: "Free Photography Tools",
  },
};
